import * as uuid from "uuid";
import {getQtCatName} from "../../../../helpers/sqftQuotesHelper";

export class HingesModel {
  id;
  shapeId
  featureId;
  qtCatName;
  partId;

  constructor(shapeId, featureId, qtCatName = null, id = uuid.v4(), partId = null, quantity = 1) {
    this.id = id;
    this.shapeId = shapeId;
    this.featureId = featureId;
    this.qtCatName = qtCatName ? qtCatName : getQtCatName();
    this.partId = partId;
    this.quantity = quantity;
  }

  setIsDisabledInPopup = (value) => {
    this.isDisabledInPopup = value;
  }
}
